import { createStore } from "./store";

/**
 * 画面の読み上げ（aria-live）に流すお知らせ。操作の結果・接続の変化を、見ていなくても分かるようにする。
 * polite：結果の報告。assertive：操作できなくなったなど、すぐ知ってほしいこと
 */
export interface Announcement {
  id: number;
  text: string;
  tone: "polite" | "assertive";
  topic?: string;
}

let seq = 0;
export const announcements = createStore<{ polite: Announcement | null; assertive: Announcement | null }>({
  polite: null,
  assertive: null,
});

export function announce(text: string, tone: "polite" | "assertive" = "polite", topic?: string) {
  const a = { id: (seq += 1), text, tone, topic };
  announcements.set((s) => ({
    polite: topic && s.polite?.topic === topic ? null : s.polite,
    assertive: topic && s.assertive?.topic === topic ? null : s.assertive,
    [tone]: a,
  }));
}
